import axios from "axios";

export default {
    state: {
        packages: [],
        filter: {}
    },
    getters: {
        PACKAGES: state => {
            return state.packages;
        },
        PACKAGES_FILTER: state => {
            return state.filter;
        }
    },
    mutations: {
        SET_PACKAGES: (state, payload) => {
            state.packages = payload;
        },
    },
    actions: {
        GET_PACKAGES: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios
                  .get(`packages`)
                  .then(({ data, status }) => {
                    if (status === 200) {
                        commit("SET_PACKAGES", data);
                        resolve(true);
                    }
                  })
                  .catch(error => {
                    reject(error);
                });
            });
        },
    }
}